module.exports = __webpack_public_path__ + "static/media/friargate-1-large.0c778162.jpg";